import computed from './attrs/computed'
import ContractorAccountHeader from '../ContractorAccount/Header.vue'
import ProfessionalAccountHeader from '../ProfessionalAccount/Header.vue'

export default {
  name: 'DynamicHeader',
  components: {ProfessionalAccountHeader, ContractorAccountHeader},
  computed
}
